export const exportKind = {
    Archicad: 0,
    IFC: 1,
    Other: 2,
    Publisher: 3
}